import { Component, inject, signal } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTabsModule, MatTabChangeEvent } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { VehiclesTabComponent } from './tabs/vehicles-tab/vehicles-tab.component';
import { UsersTabComponent } from './tabs/users-tab/users-tab.component';
import { BusinessPartnersTabComponent } from './tabs/business-partners-tab/business-partners-tab.component';

export interface SubRouteRelationshipsModalData {
  initialTab?: number;
}

@Component({
  selector: 'app-sub-route-relationships-modal',
  standalone: true,
  imports: [
    MatDialogModule,
    MatTabsModule,
    MatButtonModule,
    MatIconModule,
    VehiclesTabComponent,
    UsersTabComponent,
    BusinessPartnersTabComponent
  ],
  templateUrl: './sub-route-relationships-modal.component.html',
  styleUrl: './sub-route-relationships-modal.component.scss'
})
export class SubRouteRelationshipsModalComponent {
  private readonly dialogRef = inject(MatDialogRef<SubRouteRelationshipsModalComponent>);
  private readonly data = inject<SubRouteRelationshipsModalData>(MAT_DIALOG_DATA, { optional: true });

  protected readonly selectedTabIndex = signal<number>(this.data?.initialTab ?? 0);

  onTabChange(event: MatTabChangeEvent): void {
    this.selectedTabIndex.set(event.index);
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
